// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3DapE","inner":"inner-37LHJ","giant":"giant-PqUl2","title":"title-MyFSM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/_notfound.css
// module id = 1231
// module chunks = 1